import React from 'react'
import PropTypes from 'prop-types'

const IconChevron = ({ className }) => (
  <svg className={className} viewBox="0 0 23 40">
    <path d="M18.05 19.35l-15.8 16.5a1.9 1.9 0 0 0 0 2.62 1.74 1.74 0 0 0 2.52 0l15.8-16.5a1.9 1.9 0 0 0 0-2.62 1.74 1.74 0 0 0-2.52 0z" />
    <path d="M20.56 18.69L4.77 2.19a1.74 1.74 0 0 0-2.51 0 1.9 1.9 0 0 0 0 2.63l15.79 16.5a1.74 1.74 0 0 0 2.51 0 1.9 1.9 0 0 0 0-2.63z" />
  </svg>
)

IconChevron.propTypes = {
  className: PropTypes.string.isRequired,
}

export default IconChevron
